import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue";
import _imports_0 from '@/assets/images/login/p_close.png';
import _imports_1 from '@/assets/images/login/p_open.png';
const _hoisted_1 = { class: "login_form" };
const _hoisted_2 = { class: "lp_form" };
const _hoisted_3 = { class: "lpfm_handle flexRow-alc flex-jcse" };
const _hoisted_4 = {
    src: _imports_0,
    class: "wh100 hg100"
};
const _hoisted_5 = {
    src: _imports_1,
    class: "wh100 hg100"
};
const _hoisted_6 = {
    key: 2,
    style: { "color": "#B2B2B2", "margin-top": "10px", "font-size": "11px", "line-height": "18px" }
};
const _hoisted_7 = { class: "lpf_btn" };
const _hoisted_8 = {
    key: 0,
    class: "lp_more flexColumn-alc flex-jcsb"
};
const _hoisted_9 = { class: "lpm_name" };
import { reactive, ref, onUnmounted, computed, toRefs } from 'vue';
import config from '@/api/config';
import { ElMessageBox } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import feedback from '@/utils/feedback';
import request from '@/api/request';
import apiUrl from '@/api/apiUrl';
import { encryptAES } from '@/utils/crypto';
const COUNT_DOWN_TOTAL = 60;
// 是否正在倒计时
export default /*@__PURE__*/ _defineComponent({
    __name: 'login_form',
    props: {
        showModules: {
            type: Array,
            default: () => ['code', 'plioy', 'forgetPassword'] // code验证码 password密码 plioy协议 
        },
        btnText: {
            type: String,
            default: '登录'
        },
        smsType: {
            type: Number,
            default: 1, // 1登录或注册 4忘记密码 
        },
        passwordVerify: {
            type: Boolean,
            default: false
        }
    },
    emits: ['submit', 'forgetPassword', 'switchNav'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const router = useRouter();
        const route = useRoute();
        const props = __props;
        const { showModules, smsType, passwordVerify } = toRefs(props);
        // 组件卸载时清除定时器，防止内存泄漏
        onUnmounted(() => {
            if (timer) {
                clearInterval(timer);
            }
        });
        const emits = __emit;
        // 按钮禁止条件
        const getDisabled = computed(() => {
            var _a, _b;
            let status = false;
            // 手机号空
            if (!form.mobile)
                status = true;
            // 验证码空
            if (((_a = showModules.value) === null || _a === void 0 ? void 0 : _a.includes('code')) && !form.code)
                status = true;
            // 密码空
            if (((_b = showModules.value) === null || _b === void 0 ? void 0 : _b.includes('password')) && !form.password)
                status = true;
            return status;
        });
        const checkedCities = ref([]);
        const onInput = (val) => {
            // 只保留数字，去掉国家区号等前缀
            form.mobile = val.replace(/\D/g, '').replace(/^(\+86|86|\+)/, '').slice(0, 11);
        };
        // 协议
        const handlePlioy = (type) => {
            /* checkedCities.value = checkedCities.value.length > 0 ? [] : ['1']
            if (route.name === '/privacy') {
                emitter.emit('privacyChange', type)
            } else {
                router.push(`/privacy?type=${type}`)
            } */
            let url;
            if (type === 'user') {
                url = config.employURL;
            }
            else if (type === 'privacy') {
                url = config.privacyURL;
            }
            else if (type === 'certification') {
                url = config.certificationURL;
            }
            window.open(url);
        };
        const form = reactive({
            mobile: '', // 手机号
            code: '', // 验证码
            password: '', // 密码
        });
        const loading = ref(false);
        const passwordType = ref('password');
        // 密码限制
        function validatePassword(password) {
            const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\p{P}\p{S}])(?!.*\s).{8,}$/u;
            return passwordRegex.test(password);
        }
        const handleSubmit = () => {
            if (!getDisabled.value) {
                next();
            }
        };
        const getMobile = () => {
            return form.mobile;
        };
        const setMobile = (mobile) => {
            form.mobile = mobile || '';
        };
        const resetForm = () => {
            form.code = '';
            form.password = '';
        };
        const next = async () => {
            var _a, _b, _c;
            // 检验手机号
            if (!/^1[3456789]\d{9}$/.test(form.mobile)) {
                feedback.msgWarning('请输入正确的手机号');
                return;
            }
            // 协议
            if ((_a = showModules.value) === null || _a === void 0 ? void 0 : _a.includes('plioy')) {
                if (checkedCities.value.length == 0) {
                    const xy = `<a href="${config.employURL}" target="_blank" style="text-decoration: none;color: #777777;" class="clickable ftBold">使用协议</a>`;
                    const ys = `<a href="${config.privacyURL}" target="_blank" style="text-decoration: none;color: #777777;" class="clickable ftBold">隐私政策</a>`;
                    try {
                        await ElMessageBox.confirm(`<div style="color: #999999;">登录即同意 <a href="${config.certificationURL}" target="_blank" style="text-decoration: none;color: #777777;" class="clickable ftBold">中国移动认证服务条款</a>，灵犀的 ${xy} 和 ${ys}。</div>`, '服务协议及隐私保护', {
                            confirmButtonText: '同意',
                            cancelButtonText: '不同意',
                            type: 'warning',
                            roundButton: true,
                            dangerouslyUseHTMLString: true,
                        });
                    }
                    catch (error) {
                        return;
                    }
                    checkedCities.value = ['1'];
                }
            }
            let params = {
                mobile: form.mobile,
            };
            if ((_b = showModules.value) === null || _b === void 0 ? void 0 : _b.includes('code')) {
                params.code = form.code;
            }
            if ((_c = showModules.value) === null || _c === void 0 ? void 0 : _c.includes('password')) {
                if (form.password.length < 8)
                    return feedback.msgWarning('密码长度不能小于8位');
                if (!validatePassword(form.password) && passwordVerify.value)
                    return feedback.msgWarning('密码必须包含大小写字母、数字和特殊字符');
                params.password = form.password;
            }
            emits('submit', params);
        };
        /**
         * @验证码倒计时
         */
        // 倒计时总时长（秒）
        const isCountingDown = ref(false);
        // 当前倒计时秒数
        const countDownSeconds = ref(COUNT_DOWN_TOTAL);
        // 定时器ID
        let timer = null;
        /**
         * 处理获取验证码逻辑
         */
        const handleGetCode = async () => {
            if (isCountingDown.value)
                return;
            if (!form.mobile)
                return feedback.msgWarning('请输入手机号');
            // 检验手机号
            if (!/^1[3456789]\d{9}$/.test(form.mobile))
                return feedback.msgWarning('请输入正确的手机号');
            let res;
            try {
                res = await request.post(apiUrl.sendCode, {
                    mobile: encryptAES(form.mobile),
                    scene: smsType.value
                });
                if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                    feedback.msgSuccess('验证码已发送');
                    startCountDown();
                }
                if ((res === null || res === void 0 ? void 0 : res.code) == 1002014004) {
                    emits('switchNav', 1);
                }
            }
            catch (error) { }
        };
        /**
         * 开始倒计时
         */
        const startCountDown = () => {
            isCountingDown.value = true;
            countDownSeconds.value = COUNT_DOWN_TOTAL;
            // 清除可能存在的定时器
            if (timer) {
                clearInterval(timer);
            }
            // 设置定时器
            timer = setInterval(() => {
                countDownSeconds.value--;
                // 倒计时结束
                if (countDownSeconds.value <= 0) {
                    endCountDown();
                }
            }, 1000);
        };
        /**
         * 结束倒计时
         */
        const endCountDown = () => {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
            isCountingDown.value = false;
            countDownSeconds.value = COUNT_DOWN_TOTAL;
        };
        __expose({
            getMobile,
            setMobile,
            resetForm
        });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_checkbox = _resolveComponent("el-checkbox");
            const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("aside", _hoisted_2, [
                    _createVNode(_component_el_input, {
                        modelValue: form.mobile,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.mobile) = $event)),
                        style: { "width": "100%", "margin-bottom": "15px" },
                        placeholder: "请输入手机号",
                        autocomplete: "tel",
                        name: "tel",
                        id: "tel",
                        onKeyup: _withKeys(handleSubmit, ["enter", "native"]),
                        maxlength: "20",
                        onInput: onInput
                    }, null, 8, ["modelValue"]),
                    (_unref(showModules).includes('code'))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "wh100 flexRow-alc lpf_more lpfm_code",
                            style: _normalizeStyle({ marginBottom: _unref(showModules).includes('password') ? '15px' : '0' })
                        }, [
                            _createVNode(_component_el_input, {
                                modelValue: form.code,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.code) = $event)),
                                class: "flex1",
                                placeholder: "请输入验证码",
                                onKeyup: _withKeys(handleSubmit, ["enter", "native"]),
                                autocomplete: "one-time-code",
                                name: "one-time-code",
                                id: "one-time-code"
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", {
                                class: _normalizeClass(["lpfm_handle flexRow-alc flex-jcse", isCountingDown.value ? 'i_color' : 'clickable']),
                                onClick: handleGetCode
                            }, _toDisplayString(isCountingDown.value ? `重新发送 ${countDownSeconds.value}s` : '获取验证码'), 3)
                        ], 4))
                        : _createCommentVNode("", true),
                    (_unref(showModules).includes('password'))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["wh100 flexRow-alc flex-jcse lpf_more", _unref(showModules).includes('forgetPassword') ? 'lpfm_password' : 'lpfm_eye'])
                        }, [
                            _createVNode(_component_el_input, {
                                modelValue: form.password,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.password) = $event)),
                                type: passwordType.value,
                                maxlength: "20",
                                class: "flex1",
                                placeholder: "请输入密码",
                                onKeyup: _withKeys(handleSubmit, ["enter", "native"]),
                                autocomplete: "current-password",
                                name: "current-password",
                                id: "current-password"
                            }, null, 8, ["modelValue", "type"]),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("p", {
                                    class: "flexRow-alc clickable",
                                    style: { "width": "15px", "height": "15px", "margin-right": "10px" },
                                    onClick: _cache[3] || (_cache[3] = ($event) => (passwordType.value = passwordType.value == 'password' ? 'text' : 'password'))
                                }, [
                                    _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
                                        [_vShow, passwordType.value === 'password']
                                    ]),
                                    _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
                                        [_vShow, passwordType.value !== 'password']
                                    ])
                                ]),
                                (_unref(showModules).includes('forgetPassword'))
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "clickable",
                                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.$emit('forgetPassword')))
                                    }, "忘记密码?"))
                                    : _createCommentVNode("", true)
                            ])
                        ], 2))
                        : _createCommentVNode("", true),
                    (_unref(showModules).includes('tips'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, " 密码需包含大小写字母、数字及特殊字符(如*&!@)，且长度在8~20位"))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_el_button, {
                            type: "primary",
                            disabled: getDisabled.value,
                            loading: loading.value,
                            onClick: next
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.btnText), 1)
                            ]),
                            _: 1
                        }, 8, ["disabled", "loading"])
                    ])
                ]),
                (_unref(showModules).includes('plioy'))
                    ? (_openBlock(), _createElementBlock("aside", _hoisted_8, [
                        _createElementVNode("div", null, [
                            _createVNode(_component_el_checkbox_group, {
                                modelValue: checkedCities.value,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((checkedCities).value = $event))
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_el_checkbox, { value: "1" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("p", _hoisted_9, [
                                                _cache[9] || (_cache[9] = _createTextVNode(" 登录即同意")),
                                                _createElementVNode("span", {
                                                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (handlePlioy('certification')), ["stop"]))
                                                }, "中国移动认证服务条款"),
                                                _cache[10] || (_cache[10] = _createTextVNode(", 灵犀的")),
                                                _createElementVNode("span", {
                                                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event) => (handlePlioy('user')), ["stop"]))
                                                }, "使用协议"),
                                                _cache[11] || (_cache[11] = _createTextVNode(" 和 ")),
                                                _createElementVNode("span", {
                                                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event) => (handlePlioy('privacy')), ["stop"]))
                                                }, "隐私政策")
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
